/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTallymarks = createReactComponent("tallymarks", "IconTallymarks", [
  ["path", { d: "M6 5l0 14", key: "svg-0" }],
  ["path", { d: "M10 5l0 14", key: "svg-1" }],
  ["path", { d: "M14 5l0 14", key: "svg-2" }],
  ["path", { d: "M18 5l0 14", key: "svg-3" }],
  ["path", { d: "M3 17l18 -10", key: "svg-4" }]
]);

export { IconTallymarks as default };
//# sourceMappingURL=IconTallymarks.js.map
